"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SmallDropdownIndicator = exports.Option = exports.Control = exports.ClearIndicator = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _reactSelect = require("react-select");
var _doubleCaretVertical = require("../../assets/icons/double-caret-vertical.svg");
var _done = require("../../assets/icons/done.svg");
var _remove = require("../../assets/icons/remove.svg");
var _commonModule = _interopRequireDefault(require("./common.module.scss"));
var _excluded = ["children"],
  _excluded2 = ["children", "isSelected"],
  _excluded3 = ["children", "prefixIcon"];
var ClearIndicator = function ClearIndicator(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_reactSelect.components.ClearIndicator, rest, children, /*#__PURE__*/_react.default.createElement(_remove.ReactComponent, {
    className: _commonModule.default['select__clear-icon'],
    "data-testid": "clear-icon"
  }));
};
exports.ClearIndicator = ClearIndicator;
var SmallDropdownIndicator = function SmallDropdownIndicator(props) {
  return /*#__PURE__*/_react.default.createElement(_reactSelect.components.DropdownIndicator, props, /*#__PURE__*/_react.default.createElement(_doubleCaretVertical.ReactComponent, {
    className: _commonModule.default['select__indicator-icon'],
    "data-testid": "select-indicator"
  }));
};
exports.SmallDropdownIndicator = SmallDropdownIndicator;
var Option = function Option(_ref2) {
  var children = _ref2.children,
    isSelected = _ref2.isSelected,
    rest = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);
  return /*#__PURE__*/_react.default.createElement(_reactSelect.components.Option, Object.assign({}, rest, {
    isSelected: isSelected
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _commonModule.default['select__selected-option']
  }, children), isSelected && /*#__PURE__*/_react.default.createElement(_done.ReactComponent, {
    "data-testid": "selected-icon",
    className: _commonModule.default['select__selected-icon']
  }));
};
exports.Option = Option;
var Control = function Control(_ref3) {
  var children = _ref3.children,
    prefixIcon = _ref3.prefixIcon,
    rest = (0, _objectWithoutProperties2.default)(_ref3, _excluded3);
  return /*#__PURE__*/_react.default.createElement(_reactSelect.components.Control, rest, prefixIcon ? /*#__PURE__*/_react.default.createElement("div", {
    className: _commonModule.default['select__prefix-icon']
  }, prefixIcon) : null, children);
};
exports.Control = Control;